// extracted by mini-css-extract-plugin
module.exports = {"container":"index__container__1YdlZ","badgeContainer":"index__badgeContainer__1BGFR","badge":"index__badge__1wI8z"};